var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9993 15C17.7339 14.9999 17.4793 14.8967 17.2917 14.7129L12.7016 10.2185C12.5113 10.0397 12.2577 9.93984 11.994 9.93984C11.7302 9.93984 11.4766 10.0397 11.2863 10.2185L6.69623 14.7129C6.50746 14.8914 6.25463 14.9902 5.9922 14.9879C5.72977 14.9857 5.47873 14.8826 5.29316 14.7009C5.10758 14.5192 5.00232 14.2734 5.00004 14.0165C4.99776 13.7595 5.09864 13.512 5.28096 13.3271L9.87106 8.83282C10.4432 8.29825 11.2036 8 11.9945 8C12.7853 8 13.5457 8.29825 14.1179 8.83282L18.707 13.3271C18.8469 13.4642 18.9422 13.6388 18.9808 13.8289C19.0194 14.0189 18.9996 14.216 18.9238 14.395C18.8481 14.574 18.7198 14.7271 18.5553 14.8348C18.3907 14.9425 18.1972 15 17.9993 15Z",
    fill: "#1A1B22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.d24ea3b0e7e324b065ed8912ec27abb3.svg";
export { ForwardRef as ReactComponent };